import {
  Id,
  Identifiable,
  List,
  project,
  ProjectStatus,
  Tag,
  Zone,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

type Activity = Identifiable<List> & {
  parentActivity: Identifiable<Activity> | null;
};

type Response = {
  uuid: string;
  name: string;
  description: string;
  endDate: string;
  completedAt: string;
  createdDate: string;
  state: "DONE" | "TODO";
  keyRank: number;
  tags: string[];
  commentsNbr?: number;
  attachmentsNbr?: number;
  attributes?: { [key: string]: string };
  minStartDate: string;
  maxEndDate: string;
  activity: {
    uuid: string;
    name: string;
    parentActivity: Identifiable<Activity> | null;
  };
  project: {
    uuid: string;
    name: string;
    template: boolean;
    zone: Identifiable<Zone>;
    status: Identifiable<ProjectStatus>;
  };
};

function renameActivities(
  activity: Identifiable<Activity> | null,
): Identifiable<List> | undefined {
  return !activity
    ? undefined
    : {
        ...activity,
        parentList: renameActivities(activity.parentActivity),
      };
}

function getMilestone(httpClient: HttpClient) {
  return (milestoneId: Id) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/milestones/${milestoneId}?projection=milestoneDetailsProjection`,
        method: HttpMethods.GET,
      })
      .then((milestone) => ({
        ...milestone,
        list: renameActivities(
          milestone.activity as Identifiable<Activity>,
        ) as Identifiable<List>,
        project: {
          ...project,
          ...milestone.project,
          // @ts-ignore
          isTemplate: milestone.project.template,
        },
        tags: milestone.tags.map((name) => ({ name })),
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            notFound: "notFound",
          }),
        ),
      );
}

export { getMilestone };
